/*eslint-disable*/
import axios from "axios";
import JwtService from "./JwtService";

const isProd = process.env.NODE_ENV === 'production' ? 'production' : 'develop'
export const AppUrl = `https://controller.inforder.eu/client_console/${isProd}/console/api/productController.php`
// export const AppUrl = 'http://207.180.229.169/client_console/production/console/api/productController.php'
export const AnalyticsUrl = `https://controller.inforder.eu/client_console/${isProd}/console/api/analyticsController.php`

export const guest_api = axios.create({
  method: 'POST',
  url: AppUrl,
  headers: {
    // Origin: AppUrl,
    'content-type': "application/x-www-form-urlencoded",
  },
  auth: {
    username: `inforderclient`,
    password: `infoRd3r`,
  }
})

export const user_api = axios.create({
  // method: 'POST',
  // url: AppUrl,
  headers: {
    // Origin: AppUrl,
    'content-type': "application/json",
    // Authorization: `Bearer ${JwtService.getToken()}`
  }
})


// WEBPACK FOOTER //
// ./src/assets/js/variables.js